import React, { useState, useEffect } from 'react';

export default function TestAPI() {
    const [data, setData] = useState([]);

     
    function createOrder(){
        fetch('/createOrder',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "order_id": "order_1626945143520",
                "order_amount": "10.12",
                "order_currency": "INR",
                "order_note": "Additional order info",
                "customer_details": {
                    'customer_id': '1',
                    'customer_email': 'name@example.com',
                    'customer_phone': '91921234567',
                }
                })})
            .then(res => res.json())
            .then(data => setData(data))
            .catch(err => console.log(err))
    }
    console.log(data)
    useEffect(() => {
        
    }, []);
    console.log(data)
    return(
        <>
        <h1>Cashfree Test</h1>
        <button onClick={()=>createOrder()}>Create Order</button>
        </>
    )
}